import React, { 
    memo, 
    useState 
} from 'react';
import axios from 'axios';

// componentes
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import OptionSelect from './OptionSelect';

// componente
function ComboGrupos({
    grupos,
    onChange,
    podeRemoverGrupoSeguroAventura=true
}) {

    const [salvando, alterarSalvando] = useState(false);

    // salva
    async function salvar(inputValue){
        alterarSalvando(true);

        try {

            // faz a requisição
            const { data } = await axios.post(`/grupos`, { dados: { id: null, descricao: inputValue } });
            onChange([...grupos, data.dados.dados]);

        } catch({ response }) {
            console.error(response);
        } finally {
            alterarSalvando(false);
        }
    }

    // faz a consulta
    async function consultar(inputValue, callback = null){

        try {

            // faz a requisição
            const { data } = await axios.get(`/grupos`, {
                params: {
                    texto: inputValue,
                    registrosPorPagina: 7
                }
            });

            // filtra registros, desabilita quem já está na lista
            const registros = data.registros.map(grupo => {
                // verifica se já está adicionado
                if(grupos.find(gruposFind => {
                    if(gruposFind.id === grupo.id){
                        return true;
                    }
                    return false;
                })){
                    grupo.isDisabled = true;
                }
                return grupo;
            });

            if(callback !== null) callback(registros);

        } catch({ response }){
            console.log(response);
        }
        
    }

    return (
        <div>
            <AsyncCreatableSelect
                isDisabled={salvando}
                loadOptions={consultar}
                isMulti
                onCreateOption={salvar}
                options={grupos}
                value={grupos.map(opcao => {
                    return {
                        label: opcao.descricao, 
                        value: opcao.id
                    }
                })}
                components={{ Option: OptionSelect }}
                onChange={(_, validar) => {
                    // verifica ações
                    if(validar.action === 'pop-value') {
                        grupos.pop();
                        onChange([...grupos]);
                    } else if(validar.action === 'remove-value') {
                        // se não está permitindo remover grupo seguro aventura, não faz nada
                        if(validar.removedValue.value === "27" && !podeRemoverGrupoSeguroAventura) return;

                        // dispara alteração
                        onChange(grupos.filter((grupo) => {                            
                            if(grupo.id === validar.removedValue.value) {
                                return false;
                            }
                            return true
                        }));
                    } else if(validar.action === 'clear') {
                        if(!podeRemoverGrupoSeguroAventura) return;
                        onChange([]);
                    } else if(validar.action === 'select-option') {
                        onChange([...grupos, validar.option]);
                    }
                }}
                formatCreateLabel={() => 'Salvar'}
                loadingMessage={() => 'Carregando...'}
                noOptionsMessage={() => 'Digite algo para fazer a consulta ou cadastrar'}
                placeholder={'Grupos'}
            />
        </div>
    )
}

export default memo(ComboGrupos);